import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogTitle,
} from "../alert-dialog";
import { LucideXCircle } from "lucide-react";
const Icon = () => (
  <div className="bg-red-100 rounded-full">
    <LucideXCircle strokeWidth={2} 
    className="h-9 w-9 text-red-600 m-2 flex-shrink-0"
     />
  </div>
);

 type ErrorDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  description?: string
}

const ErrorDialog = ({ open, onOpenChange, title, description } : ErrorDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>

      <AlertDialogContent className="z-50">
        <AlertDialogHeader className="flex items-center gap-2">
          <Icon />
          <AlertDialogTitle className="font-bold text-xl">
            {
              title || "Error"
            }
          </AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription className="text-center ">
          {description ||  "Something went wrong. Please try again."}
        </AlertDialogDescription>
        <AlertDialogFooter className="flex sm:justify-center sm:mt-3">
          <AlertDialogCancel className="bg-gray-100">Close</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
      <AlertDialogOverlay className="z-40 bg-black/50" />

    </AlertDialog>
  );
};

export default ErrorDialog;
